<script lang="ts" setup>
/**
 * リプライ一覧。
 */

import { defineProps } from "vue";
import { ReplyDto } from "@/apiRequests/models/communityTalk/replyGetResponse";
import ReplyMaster from "@/components/communityTalk/reply/ReplyMaster.vue";
import { LayoutTagGetResponse_WordSetting } from "@/apiRequests/models/communityTalk/layoutTagGetResponse";

interface Props {
	/**
	 * リプライ情報群。
	 */
	replies: ReplyDto[];
	/**
	 * 表示タグ設定>文言設定。
	 */
	wordSettings: LayoutTagGetResponse_WordSetting;
	/**
	 * CommunityTalkStoreのInject用キー。
	 */
	communityTalkStoreKey: string;
	/**
	 * ReplyPostStoreのInject用キー。
	 */
	replyPostStoreKey: string;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef
const props = defineProps<Props>();
</script>

<template>
	<section class="revico-community-talk-reply">
		<h1 class="revico-community-talk-reply--title">リプライ一覧</h1>
		<ul class="revico-community-talk-reply-list">
			<li v-for="(reply, index) in replies" :key="index" class="revico-community-talk-reply-list-item">
				<ReplyMaster :reply="reply" :wordSettings="wordSettings" :communityTalkStoreKey="communityTalkStoreKey" :replyPostStoreKey="replyPostStoreKey" />
			</li>
		</ul>
	</section>
</template>

<style lang="scss">
.revico-widget .revico-community-talk {
	&-reply {
		width: 100%;

		&--title {
			display: none;
		}
		&-list {
			&-item {
				margin-bottom: 12px;

				&:last-child {
					margin-bottom: 0;
				}
			}
		}
	}
}
</style>
